import lazyLoadView from './lazy-load-view'
import membersGuard from '../guards/members'
import memberRegisterGuard from '../guards/member-register'
import memberLoginGuard from '../guards/member-login'
import memberLogoutGuard from '../guards/member-logout'
import memberProfileGuard from '../guards/member-profile'
import memberBookingHistoryGuard from '../guards/member-booking-history'
import memberVouchersGuard from '../guards/member-vouchers'
import memberRedeemGuard from '../guards/member-redeem'

export default [
  {
    path: '/members/:permalink',
    component: () => lazyLoadView(import('@layouts/master')),
    meta: { beforeResolve: membersGuard },
    props: ({ params }) => ({
      layout: params.layout,
      layoutComponents: params.layoutComponents,
      property: params.property,
    }),
    children: [
      {
        path: 'register',
        name: 'member-register',
        component: () => lazyLoadView(import('@views/member-register')),
        meta: { beforeResolve: memberRegisterGuard },
        props: ({ params }) => ({ property: params.property, dropdown: params.dropdown }),
      },
      {
        path: 'login',
        name: 'member-login',
        component: () => lazyLoadView(import('@views/member-login')),
        meta: { beforeResolve: memberLoginGuard },
        props: ({ params }) => ({ property: params.property }),
      },
      {
        path: 'logout',
        name: 'member-logout',
        meta: {
          authRequired: true,
          beforeResolve: memberLogoutGuard,
        },
      },
      {
        path: 'profile',
        name: 'member-profile',
        component: () => lazyLoadView(import('@views/member-profile')),
        meta: {
          authRequired: true,
          beforeResolve: memberProfileGuard,
        },
        props: ({ params }) => ({
          property: params.property,
          dropdown: params.dropdown,
        }),
      },
      {
        path: 'booking-history',
        name: 'member-booking-history',
        component: () => lazyLoadView(import('@views/member-booking-history')),
        meta: {
          authRequired: true,
          beforeResolve: memberBookingHistoryGuard,
        },
        props: ({ params }) => ({
          property: params.property,
          histories: params.histories,
        }),
      },
      {
        path: 'vouchers',
        name: 'member-vouchers',
        component: () => lazyLoadView(import('@views/member-vouchers')),
        meta: {
          authRequired: true,
          beforeResolve: memberVouchersGuard,
        },
        props: ({ params }) => ({
          property: params.property,
          vouchers: params.vouchers,
        }),
      },
      {
        path: 'redeem',
        name: 'member-redeem',
        component: () => lazyLoadView(import('@views/member-redeem')),
        meta: {
          authRequired: true,
          beforeResolve: memberRedeemGuard,
        },
        props: ({ params }) => ({
          property: params.property,
          vouchers: params.vouchers,
        }),
      },
    ],
  },
]
